import React from 'react';
import styles from './TabelaMadeiras.module.scss';
import { Madeira } from '../../interfaces/madeira.interface';

interface TabelaMadeirasProps {
  madeiras: Madeira[];
}

export default function TabelaMadeiras({ madeiras }: TabelaMadeirasProps) {
  if (madeiras.length === 0) return null;

  return (
    <div className={styles.container}>
      <h4>Pré-visualização dos dados</h4>
      <table className={styles.tabela}>
        <thead>
          <tr>
            <th>COD</th>
            <th>DOF</th>
            <th>NF</th>
            <th>Comprimento</th>
            <th>Expessura</th>
            <th>Largura</th>
            <th>m³</th>
            <th>Valor</th>
            <th>Produto</th>
            <th>Quantidade</th>
            <th>Tora</th>
            <th>Processada</th>
          </tr>
        </thead>
        <tbody>
          {madeiras.map((madeira, index) => (
            <tr key={index}>
              <td>{madeira.COD}</td>
              <td>{madeira.DOF}</td>
              <td>{madeira.NF}</td>
              <td>{madeira.comprimento}</td>
              <td>{madeira.expessura}</td>
              <td>{madeira.largura}</td>
              <td>{madeira.metroCubico}</td>
              <td>{madeira.valor}</td>
              <td>{madeira.produto}</td>
              <td>{madeira.quantidade}</td>
              <td>{madeira.tora}</td>
              <td>{madeira.processada ? 'Sim' : 'Não'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
